(() => {
  const selector = 'maoni-set-configurator[data-maoni-dynamic-variant-groups]';

  const normalize = (value) => String(value || '')
    .toLocaleLowerCase('de-DE')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const variantText = (variant) => {
    if (!variant) return '';
    const values = [variant.title, variant.option1, variant.option2, variant.option3];
    if (Array.isArray(variant.options)) values.push(...variant.options);
    return normalize(values.filter(Boolean).join(' '));
  };

  const displayColor = (key) => ({
    beige: 'Beige',
    schwarz: 'Schwarz',
    taupe: 'Taupe',
    dunkeltaupe: 'Dunkeltaupe',
    dunkelgrau: 'Dunkelgrau',
    dunkelblau: 'Dunkelblau',
    cognac: 'Cognac',
    braun: 'Braun',
    grun: 'Grün',
    beige_gold: 'Beige Gold',
    schwarz_gold: 'Schwarz Gold',
    taupe_gold: 'Taupe Gold',
    dunkeltaupe_gold: 'Dunkeltaupe Gold',
    cognac_gold: 'Cognac Gold',
    hellgrau: 'Hellgrau',
    hellgrau_gold: 'Hellgrau Gold',
    metallic_bronze: 'Metallic Bronze',
    bordeaux: 'Bordeaux'
  }[key] || 'gewählte Farbe');

  const findGroupKey = (configurator, variant) => {
    const text = variantText(variant);
    if (!text) return '';

    const keys = Array.from(configurator.querySelectorAll('[data-maoni-variant-group]'))
      .map((card) => card.dataset.maoniVariantGroup || '')
      .filter(Boolean)
      .filter((key, index, all) => all.indexOf(key) === index)
      .sort((a, b) => normalize(b).length - normalize(a).length);

    return keys.find((key) => text.includes(normalize(key))) || '';
  };

  const applyVariantGroup = (configurator, variant) => {
    const activeKey = findGroupKey(configurator, variant);
    const cards = Array.from(configurator.querySelectorAll('[data-maoni-variant-group]'));

    cards.forEach((card) => {
      const isActive = Boolean(activeKey) && card.dataset.maoniVariantGroup === activeKey;
      card.hidden = !isActive;
      card.querySelectorAll('input[data-maoni-accessory]').forEach((input) => {
        if (!isActive) input.checked = false;
        input.disabled = !isActive;
      });
    });

    const noAccessoryInputs = Array.from(configurator.querySelectorAll('input[data-maoni-no-accessory]'));
    const legacyNoStrap = configurator.querySelector('input[data-maoni-no-accessory="strap"]');
    if (legacyNoStrap && !noAccessoryInputs.includes(legacyNoStrap)) noAccessoryInputs.push(legacyNoStrap);
    noAccessoryInputs.forEach((input) => {
      input.checked = true;
    });

    const colorLabel = configurator.querySelector('[data-maoni-active-color-label]');
    if (colorLabel) {
      const color = activeKey ? displayColor(activeKey) : (variant?.title || 'gewählte Variante');
      colorLabel.textContent = 'Passende Auswahl für: ';
      const strong = document.createElement('strong');
      strong.textContent = color;
      colorLabel.appendChild(strong);
    }

    const emptyMessage = configurator.querySelector('[data-maoni-no-variant-group-message]');
    if (emptyMessage) emptyMessage.hidden = Boolean(activeKey);

    configurator.dataset.maoniActiveVariantGroup = activeKey;
    if (typeof configurator.updateSummary === 'function') configurator.updateSummary();
  };

  const init = (configurator) => {
    if (!configurator || configurator.dataset.maoniDynamicGroupsInitialized === 'true') return;
    configurator.dataset.maoniDynamicGroupsInitialized = 'true';

    const productRoot = configurator.closest('product-form');
    productRoot?.addEventListener('on:variant:change', (event) => {
      if (!event.detail?.variant) return;
      applyVariantGroup(configurator, event.detail.variant);
    });

    applyVariantGroup(configurator, configurator.currentBagVariant || null);
  };

  const initAll = (root = document) => {
    root.querySelectorAll(selector).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
